export default function getSearchWidgetTranslations(language) {
  if (language === "fr-FR") return {
    arrivalDate: "Date d'arrivée",
    departureDate: "Date de départ",
    searchButton: "Rechercher",
    lodging: "Hébergement",
    overnatting: "Accomodation",
    activities: "Activités",
    lodgingSlug: "hebergement",
    activitiesSlug: "activites",
    guests: "Invités",
    room: "chambre",
    addRoom: "Ajouter une chambre",
    adults: "adultes",
    ages: "Âges",
    age: "âge",
    children: "enfants",
    child: "enfant",
    ageDescriptionAdults: "Âges {age} ans ou plus",
    ageDescriptionChildren: "Âges {age}",
    lodgingTL: 'Lodging',
    lodgingSlugTL: 'lodging',
    activitiesTL: 'Activities',
    activitiesSlugTL: 'activities',
    liftticketsTL: 'Lift Tickets',
    liftticketsSlugTL: 'lift-tickets',
    seasonPassTL: 'Season Pass',
    seasonPassSlugTL: 'season-pass-regular'
  }
  if(language === "en-US") return {
    arrivalDate: "Arrival Date",
    departureDate: "Departure Date",
    searchButton: "Search",
    lodging: "Lodging",
    overnatting: "Accomodation",
    activities: "Activities",
    lifttickets: "Lift Tickets",
    seasonpass: "Season Pass",
    lodgingSlug: "lodging",
    activitiesSlug: "4ct1v1t13s",
    liftticketsSlug: "test-lift-tickets",
    seasonpassSlug: "season-pass",
    guests: "Guests",
    room: "room",
    addRoom: "Add room",
    adults: "Adults",
    ages: "Ages",
    age: "Age",
    children: "Children",
    child: "child",
    ageDescriptionAdults: "Ages {age} or above",
    ageDescriptionChildren: "Ages {age}",
    lodgingTL: 'Lodging',
    lodgingSlugTL: 'lodging',
    activitiesTL: 'Activities',
    activitiesSlugTL: 'activities',
    liftticketsTL: 'Lift Tickets',
    liftticketsSlugTL: 'lift-tickets',
    seasonPassTL: 'Season Pass',
    seasonPassSlugTL: 'season-pass-regular'
  }
  if(language === "nb-NO" || language === "no-NO") return {
    arrivalDate: "Ankomst",
    departureDate: "Avreise",
    searchButton: "Søk",
    lodging: "Losji",
    overnatting: "Overnatting",
    activities: "Aktiviteter",
    lifttickets: "Heiskort",
    liftticketsSlug: "test-heiskort",
    seasonpass: "Sesongkort",
    seasonpassSlug: "sesongkort",
    lodgingSlug: "losji",
    activitiesSlug: "4kt1v1t3t3r",
    guests: "Gjester",
    room: "rom",
    addRoom: "Legge til rom",
    adults: "Voksne",
    ages: "Aldre",
    age: "Alder",
    children: "Barn",
    child: "Barn",
    ageDescriptionAdults: "{age} år eller eldre",
    ageDescriptionChildren: "Alderen {age}",
    lodgingTL: 'Overnatting',
    lodgingSlugTL: 'losji',
    activitiesTL: 'Aktiviteter',
    activitiesSlugTL: 'aktiviteter',
    liftticketsTL: 'Heiskort',
    liftticketsSlugTL: 'heiskort',
    seasonPassTL: 'Sesongkort',
    seasonPassSlugTL: 'sesongkort-regular'
  }
  return {
    arrivalDate: "Arrival Date",
    departureDate: "Departure Date",
    searchButton: "Search",
    lodging: "Lodging",
    overnatting: "Accomodation",
    activities: "Activities",
    lodgingSlug: "l0dg1ng",
    activitiesSlug: "4ct1v1t13s",
    lifttickets: "Lift tickets",
    liftticketsSlug: "test-heiskort",
    seasonpass: "Season pass",
    seasonpassSlug: "sesongkort",
    guests: "Guests",
    room: "room",
    addRoom: "Add room",
    adults: "Adults",
    ages: "Ages",
    age: "age",
    children: "Children",
    child: "child",
    ageDescriptionAdults: "Ages {age} or above",
    ageDescriptionChildren: "Ages {age}",
    lodgingTL: 'Lodging',
    lodgingSlugTL: 'lodging',
    activitiesTL: 'Activities',
    activitiesSlugTL: 'activities',
    liftticketsTL: 'Lift Tickets',
    liftticketsSlugTL: 'lift-tickets',
    seasonPassTL: 'Season Pass',
    seasonPassSlugTL: 'season-pass-regular'
  }
}
